module.exports = __webpack_public_path__ + "img/2308-stmp1.9990602c.png";